module.exports = __webpack_public_path__ + "static/media/sort-arrow-icon.ab0ce63a.svg";